import { fetchSrmUsers } from "../qv4/models/shared/agentsUsersModel";
import { fetchCanonicalAssignees } from "./canonicalMessagingApi";

// Fired locally after a refresh. The server's chat-members event (socket)
// triggers a refresh too; see CanonicalMessagingContext.
export const AGENT_ELIGIBILITY_CHANGED = "uzdpart360:agent-eligibility-changed";
export const CHAT_MEMBERS_CHANGED_EVENT = "messaging:chat_members_changed";
let revision = 0;
export const humanAgents = users => users.filter(user => !user.is_messaging_service_account);
export function subscribeAgentEligibility(listener) {
  const handle = event => listener(event.detail);
  window.addEventListener(AGENT_ELIGIBILITY_CHANGED, handle);
  return () => window.removeEventListener(AGENT_ELIGIBILITY_CHANGED, handle);
}
export async function refreshAgentEligibility() {
  const current = ++revision;
  window.dispatchEvent(new CustomEvent(AGENT_ELIGIBILITY_CHANGED, { detail: null }));
  const [users, assignees] = await Promise.all([fetchSrmUsers({ force: true, strict: true }), fetchCanonicalAssignees()]);
  if (current === revision) window.dispatchEvent(new CustomEvent(AGENT_ELIGIBILITY_CHANGED, { detail: { users, assignees } }));
  return { users, assignees };
}

export function agentWorkloadLabel(chat, users) {
  const owner = users.find(user => String(user.value ?? user.id) === String(chat.agent_id));
  return owner?.is_messaging_service_account ? "Service-owned chats" : String(chat.agent || "").trim() || "Unassigned";
}
